import { PlusIconTwoTone } from '@room-match/shared-ui-components';
import { AddRepresentativesButton } from './AddRepresentatives.styles';
import { Fragment } from 'react/jsx-runtime';
import { memo, useState, lazy, Suspense, useCallback } from 'react';
import { useRepresentativesContext } from 'pages/Representatives/context/RepresentativesProvider';
const AddRepresentativesModalLazy = lazy(() => import('./components/AddRepresentativesModal/AddRepresentativesModal'));

const AddRepresentatives = () => {
  // Getting the profiles data
  const { profiles, isLoading, isFetching } = useRepresentativesContext();
  const hasFreelance = profiles?.some((profile) => profile?.representation_type === 'non_represented') || false;
  // AddRepresentatives Modal Functionality
  const [openAddRepresentativesModal, setOpenAddRepresentativesModal] = useState<boolean>(false);
  // Notification Modal Functionality

  // Open Modal Action
  const handleModal = useCallback(() => {
    setOpenAddRepresentativesModal((prev) => !prev);
  }, []);

  return (
    <Fragment>
      {/* Add Representatives Button */}
      <AddRepresentativesButton onClick={handleModal} disabled={isLoading || isFetching}>
        <span>
          <PlusIconTwoTone />
          <p>Add a new Representative</p>
        </span>
      </AddRepresentativesButton>
      {/* Add Representatives Modal */}
      {openAddRepresentativesModal ? (
        <Suspense fallback={''}>
          <AddRepresentativesModalLazy
            open={openAddRepresentativesModal}
            handleOnClose={handleModal}
            hasFreelance={hasFreelance}
          />
        </Suspense>
      ) : null}
    </Fragment>
  );
};

export default memo(AddRepresentatives);
